<script setup>
import {onMounted, ref} from "vue";
import BlogTable from '@/components/Rule/BlogTable.vue'
import NavPicker from '@/components/Rule/NavPicker.vue'
import Blog from '@/components/Rule/Blog.vue'
import { useToast } from "vue-toastification"

const en =ref(null)
const tw =ref(null)
const blogs = ref([]);
const showModal = ref(false)
const blog = ref(null)
const toast = useToast()

async function getWorkRule(){
    const response = await axios.get('/api/rules')
    en.value = response.data.data.en
    tw.value = response.data.data.tw
}

async function getBlogs(params={}){
    params.content = null
    const response = await axios.get('/api/blogs', {
        params
    })
    blogs.value = response.data.data
}

async function fetchBlog(id){
    const response = await axios.get(`/api/blogs/${id}?content=1`)
    blog.value = response.data.data
    showModal.value = true
}

async function closeModal() {
    showModal.value = false
    blog.value = null
    await getBlogs()
}

async function confirm(id){
    if (!id) {
        await closeModal()
    } else {
        await axios.patch(`/api/blogs/${id}`)
        toast.success('you already read this article')
        await closeModal()
    }
}

onMounted(async() => {
    await getWorkRule()
    await getBlogs()
})

</script>


<template>
    <div class="flex flex-col ">
        <div>
            <div class="font-bold text-2xl">Bulletin</div>
            <p>Hi everyone you must read, when you start your work.</p>
            <hr class="my-2">
            <p>
                <a v-if="en" class="text-indigo-700" :href="en" target="_blank">English</a>
                <span v-if="tw && en">|</span>
                <a v-if="tw" class="text-indigo-700" :href="tw" target="_blank">TW</a>
            </p>
        </div>
        <div class="mt-4 grid grid-cols-1 gap-4">
            <NavPicker
                @search="getBlogs"
            />
            <hr>
            <BlogTable
                @show="fetchBlog"
                :items="blogs"
            />
        </div>
    </div>
    <vue-final-modal
        v-model="showModal"
        classes="flex justify-center items-center px-2 py-4"
        @closed="closeModal"
    >
        <Blog
            :blog="blog"
            @confirm="confirm"
        />
    </vue-final-modal>
</template>
